import { useIsInverseVariant as c } from "./theme-variant-context.js";
import { useTheme as o, useScreenSize as d } from "./hooks.js";
import u from "./nestable-context.js";
import { isInsideNovumNativeApp as p, getPlatform as v } from "./utils/platform.js";
import { vars as t } from "./skins/skin-contract.css-mistica.js";
import { jsx as e, Fragment as s, jsxs as f } from "./_virtual/jsx-runtime.js";
const { Provider: g , Getter: h , useSetValue: b  } = u(""), i = (r)=>v(r) === "ios", P = (param)=>{
    let { children: r  } = param;
    const { platformOverrides: n  } = o(), { isTabletOrSmaller: l  } = d(), a = o();
    return i(n) ? /* @__PURE__ */ e(g, {
        children: /* @__PURE__ */ e(h, {
            children: (m)=>/* @__PURE__ */ f(s, {
                    children: [
                        l ? /* @__PURE__ */ e("div", {
                            style: {
                                position: "absolute",
                                zIndex: 1,
                                background: m || t.colors.background,
                                width: "100%",
                                height: 500 + (p(n) ? 0 : a.dimensions.headerMobileHeight),
                                left: 0,
                                marginTop: -500,
                                transform: "translate3d(0,0,0)"
                            }
                        }) : null,
                        r
                    ]
                })
        })
    }) : /* @__PURE__ */ e(s, {
        children: r
    });
}, O = ()=>{
    const r = c();
    return b(r ? t.colors.navigationBarBackground : t.colors.background), null;
}, T = ()=>i(o().platformOverrides) ? /* @__PURE__ */ e(O, {}) : /* @__PURE__ */ e(s, {});
export { P as OverscrollColorProvider, T as default };
